/**
 * Created by anatoly on 04.03.2025
 */

const MergeHintView = function () {
    this.cell = undefined;

    cleverapps.availableMove.on("hide", this.hide.bind(this));
    cleverapps.availableMove.on("merge", this.show.bind(this));
};

MergeHintView.prototype.show = function (move) {
    this.hide();

    this.move = move;

    const unitViews = this.listUnitViews();
    if (unitViews.length < 2) {
        return;
    }

    if (this.move.finger) {
        this.hintFinger = FingerView.hintSwipe(unitViews[0], unitViews[1], {
            delay: move.delay / 1000,
            repeatDelay: move.interval / 1000
        });
        return;
    }

    this.highlight();
};

MergeHintView.prototype.showFingerOnce = function () {
    const unitViews = this.move ? this.listUnitViews() : [];
    if (unitViews.length < 2) {
        return;
    }

    this.hintFinger = FingerView.hintSwipe(unitViews[0], unitViews[1], { runOnce: true });
};

MergeHintView.prototype.listUnitViews = function () {
    return this.move.cells
        .map((cell) => Merge2.current.field.getUnit(cell.x, cell.y))
        .filter(Boolean)
        .map((unit) => unit.onGetView())
        .filter(Boolean);
};

MergeHintView.prototype.highlight = function () {
    const unit = Merge2.current.field.getUnit(this.move.cells[0].x, this.move.cells[0].y);
    const mergeComponent = unit && unit.findComponent(MergeComponent);
    if (!mergeComponent) {
        return;
    }

    let cycle = 0;
    mergeComponent.highlightMergeHint(this.move.cells, {
        delay: this.move.delay / 1000,
        interval: this.move.interval / 1000,
        onCycle: () => {
            if (cycle++ % MergeHintView.FINGER_EVERY_CYCLES === 0) {
                this.showFingerOnce();
            }
        }
    });
    this.mergeComponent = mergeComponent;
};

MergeHintView.FINGER_EVERY_CYCLES = 4;

MergeHintView.prototype.hide = function () {
    this.move = undefined;

    if (this.hintFinger) {
        FingerView.remove(this.hintFinger);
        this.hintFinger = undefined;
    }

    const mergeComponent = this.mergeComponent;
    this.mergeComponent = undefined;

    if (mergeComponent) {
        mergeComponent.unhighlightUnits();
    }
};
